import { render } from "./HeaderNav.vue?vue&type=template&id=5a98e854&scoped=true"
import script from "./HeaderNav.vue?vue&type=script&lang=js"
export * from "./HeaderNav.vue?vue&type=script&lang=js"

import "./HeaderNav.vue?vue&type=style&index=0&id=5a98e854&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a98e854"]])

export default __exports__